import { fetchJSON } from '@bonnet/core/fetch';
import { logger } from '@bonnet/core/logger';
import cache from '../cache';
import constants from '../constants';
import getReferenceApiPath from './getReferenceApiPath';
const {
  MARKETS
} = constants;
const circuitBreaker = {
  id: 'market',
  timeout: 20000,
  fallback: {
    success: false,
    payload: {}
  }
};
function lookupZip(city, state, markets) {
  const resKey = Object.keys(markets).find(key => {
    var _markets$key$city, _markets$key$state;
    return ((_markets$key$city = markets[key].city) === null || _markets$key$city === void 0 ? void 0 : _markets$key$city.toUpperCase()) === city.toUpperCase() && ((_markets$key$state = markets[key].state) === null || _markets$key$state === void 0 ? void 0 : _markets$key$state.toUpperCase()) === state.toUpperCase();
  });
  return markets[resKey];
}
export default async function getMarketFromCityState(_ref) {
  let {
    city,
    state
  } = _ref;
  let response;
  try {
    let success = false;
    let payload;

    // retrieve zipcodes from cache or get them from the remote API
    const markets = await cache.get(MARKETS);

    // lookup market data in markets table by city and state
    const market = lookupZip(city, state, markets);

    // return cached market data if we have it
    if (market) {
      success = true;
      payload = market;
    } else {
      // If market is not available from memory cache then we need to fetch it from the API
      const marketResponse = await fetchJSON(getReferenceApiPath(MARKETS), {
        circuitBreaker,
        query: {
          city,
          state
        }
      });
      if (marketResponse.success) {
        ({
          success,
          payload
        } = marketResponse);
      }
    }
    if (!success) {
      throw Error(`cannot find zipcode data for ${city} ${state}`);
    }
    response = {
      success,
      payload
    };
  } catch (error) {
    const {
      message
    } = error;
    if (process.env.NODE_ENV === 'development') {
      logger.log(`[@atc/bonnet-reference/getMarket] ${message}`);
    }
    response = {
      success: false,
      message,
      error
    };
  }
  return response;
}